var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"bg-1"},[_c('navbar'),_c('search-medecins'),_c('div',[(_vm.loading)?_c('loading-page'):_c('medecins-specialite',{attrs:{"doctors":_vm.doctors}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }